<div class="notice-container" [class.open]="isOpen()">

    <!-- Anchored FAB toggler -->
    @if ((notices$ | async)?.length) {
        <button mat-fab color="primary" class="notice-toggle" (click)="toggleOpen()">
            @if (!isOpen()) {
                <app-icon icon="warning"></app-icon>
            } @else {
                <app-icon icon="caret-down"></app-icon>
            }
            @if ((notices$ | async)?.length && !isOpen()) {
                <span class="badge">{{ (notices$ | async)?.length }}</span>
            }
        </button>
    }

    <!-- Floating notice list -->
    @if (isOpen()) {
        <div class="notice-list">
            <div class="scrollable">
                @for (n of (notices$ | async); track n.id) {
                    <div class="notice-bubble" [ngClass]="noticeClass(n)"
                         (click)="expand(n)"
                         animate.enter="slide-in-bubble"
                         animate.leave="slide-out-bubble">
                        <app-icon [icon]="noticeIcon(n)"></app-icon>
                        <div class="bubble-text">
                            <div class="title">{{ n.title }}</div>
                            <div class="preview">{{ n.preview }}</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</div>

<!-- Expanded notice overlay -->
@if (expandedNotice()) {
    <div class="expanded-overlay" (click)="closeExpanded()">
        <mat-card class="expanded-card"
                  (click)="$event.stopPropagation()"
                  animate.enter="zoom-in"
                  animate.leave="zoom-out">

            <div class="expanded-header">
                <app-icon icon="warning"></app-icon>
            </div>

            <!-- Use innerHTML for HTML-formatted text -->
            <div class="expanded-body" [innerHTML]="expandedNotice()?.text"></div>
        </mat-card>
    </div>
}
